// extracted by mini-css-extract-plugin
module.exports = {"license":"License_license__1rGul","blur":"License_blur__1lFU0","contact":"License_contact__3zdE7","premium":"License_premium__1jwl-"};